(function(window, app, overwatch, $, _) {

    // Defines the interface of a search result, transformed from API result
    function transformResult(result) {
        result['svg_id'] = result.platform + '-icon';
        return result;
    }

    var search = {
        searchResults: [],
        cacheElements: function cacheElements() {
            this.$searchResultsArea = $('.search-results');
            this.$searchResultsItemsArea = $('#search-result-items');
            this.$searchUserMessages = $('#search-user-messages');
            this.$searchResultsCount = $('#search-results-count');
        },
        cacheTemplates: function cacheTemplates() {
            this.searchResultItemTemplate = _.template(document.getElementById('search-result-item-template').innerHTML);
            this.generalErrorMessage = _.template(document.getElementById('search-result-fail-template').innerHTML)();
            this.notFoundErrorMessage = _.template(document.getElementById('search-result-zero-template').innerHTML)();
            this.platformNotFoundErrorMessage = _.template(document.getElementById('search-result-zero-platform-template').innerHTML)();
        },
        loadResults: function loadResults(accountName) {
            var self = this,
                url = '';
            //bnet account names can't contain any symbols, so this is safe. https://us.battle.net/support/en/article/26963
            accountName = accountName.replace(/-/g, '#');
            url = '/'+clientVars.urlLocale+'/search/account-by-name/'+encodeURIComponent(accountName);

            self.searchResults = [];
            self.$searchUserMessages.hide();
            self.$searchResultsItemsArea.hide();
            $.ajax(url).done(function(results) {
                results = results.map(transformResult);
                self.$searchResultsCount.text(results.length);
                self.searchResults = results;

                if(self.searchResults.length !== 0) {
                    self.generateResultHtml(self.searchResults);
                    self.$searchResultsItemsArea.show();
                    self.$searchUserMessages.hide();
                } else {
                    self.updateErrorMessage(self.notFoundErrorMessage);
                    self.$searchResultsItemsArea.hide();
                }
            }).fail(function(err, results) {
                self.updateErrorMessage(generalErrorMessage);
            }).always(function() {
                self.$searchResultsArea.removeClass('is-loading');
            });
        },
        generateResultHtml: function generateResultHtml(results) {
            var searchResultHtml = "";
            for(i=0, len=results.length; i<len; i++) {
                searchResultHtml += this.searchResultItemTemplate(results[i]);
            }
            this.$searchResultsItemsArea.html(searchResultHtml);
        },
        updateErrorMessage: function updateErrorMessage(html) {
            if(html) {
                this.$searchUserMessages.html(html);
                this.$searchUserMessages.show();
            }
        },
        applyPlatformFilter: function applyPlatformFilter() {
            var $filterOptions = $('input[name=filter]:checked');
            var filteredResults = 0;

            //show all the results if no filter is selected
            if($filterOptions.length === 0) {
                $('.player-badge-wrapper', this.$searchResultsItemsArea).show();
                this.$searchUserMessages.hide();
            } else {
                this.$searchResultsItemsArea.children().hide();
                $filterOptions.each(function() {
                    var filterValue = $(this).val();
                    var badgesForThisPlatform = $('.player-badge-wrapper[data-platform='+filterValue+']', this.$searchResultsItemsArea);
                    filteredResults += badgesForThisPlatform.length;
                    badgesForThisPlatform.show();
                });

                if(filteredResults === 0) {
                    this.updateErrorMessage(this.platformNotFoundErrorMessage);
                } else {
                    this.$searchUserMessages.hide();
                }
            }
        },
        sort: function sort(options) {
            sortedResults = _.orderBy(this.searchResults, [options.field], [options.order]);
            this.generateResultHtml(sortedResults);
        },
        setupEvents: function setupEvents() {
            var self = this;

            $('[data-js=player_search]').on("submit", function(event) {
                event.preventDefault();
                var playerName = $(this).find("input[name=q]").val();
                self.$searchResultsArea.addClass('is-loading');
                history.pushState(null, null, "/search?q="+playerName);
                self.loadResults(playerName);
            });

            $('input[name=filter]').on("change", function() {
                //don't bother filtering if there are no players to filter.
                if(self.searchResults.length !== 0) {
                    self.applyPlatformFilter();
                }
            });

            $('[data-js="sort-option"]').on("click", function(event) {
                var sortOption, sortOrder;
                event.preventDefault();
                $(this).siblings('[data-js="sort-option"]').removeClass('is-selected');
                $(this).addClass('is-selected');

                //don't bother sorting if there are no players to sort.
                if(self.searchResults.length !== 0) {
                    sortOption = $(this).data('sortOption');
                    sortOrder = (sortOption === 'level') ? 'desc' : 'asc';

                    self.sort({field: sortOption, order: sortOrder});
                    self.applyPlatformFilter();
                }
            });
        },
        init: function init(accountName) {
            this.cacheElements();
            this.cacheTemplates();
            this.loadResults(accountName);
            this.setupEvents();
        }
    };
    app.extend({ search: search });

}(window, window.app, window.overwatch, window.jQuery, window._));
